module.exports = __webpack_public_path__ + "static/media/banner-full.d1428a7b.png";